import Freelancers from "../assets/freelancersandagencies.webp";
import Startups from "../assets/Startups.webp";
import GoodsEx from "../assets/exporters.webp";
import Enterprises from "../assets/enterprise.webp";

export default function Targetaudience(){
    return(
        <div className="mt-[140px] lg:px-[10%]  px-4 text-center">
        <p className="text-4xl text-[#1A202C] text-black font-bold md:px-[10%]">
          Built for everyone receiving international payments
        </p>

        {/* Top row: 3 items */}
        <div className="flex flex-wrap justify-center gap-6 mt-10">
          {/* 1 - Freelancers */}
          <div className="relative w-full max-w-[450px]  transition-all duration-300 group ">
            <img
              src={Freelancers}
              className="rounded-[20px] w-full h-70 object-cover"
              loading="lazy"
            />
            <p className="font-semibold text-[16px] mt-[12px] text-[#1A202C]">
              Freelancers & Digital Agencies
            </p>
          </div>


          {/* 3 - Startups */}
          <div className="relative w-full max-w-[450px]  transition-all duration-300 group ">
            <img
              src={Startups}
              className="rounded-[20px] w-full h-70 object-cover"
              loading="lazy"
            />
            <p className="mt-[12px] font-semibold text-[16px] text-[#1A202C]">
              Startups
            </p>
          </div>
        </div>

        {/* Bottom row: 2 items */}
        <div className="flex flex-wrap justify-center gap-6 mt-10">
          {/* 4 - Goods Exporters */}
          <div className="relative w-full max-w-[450px]  transition-all duration-300 group ">
            <img
              src={GoodsEx}
              className="rounded-[20px] w-full h-70 object-cover"
              loading="lazy"
            />
            <p className="font-semibold text-[16px] mt-[12px] text-[#1A202C]">
              Goods Exporters
            </p>
          </div>

          {/* 5 - Enterprises */}
          <div className="relative w-full max-w-[450px]  transition-all duration-300 group ">
            <img
              src={Enterprises}
              className="rounded-[20px] w-full h-70 object-cover"
              loading="lazy"
            />
            <p className="font-semibold text-[16px] mt-[12px] text-[#1A202C]">
              Enterprises
            </p>
          </div>
        </div>
      </div>
    )
}